<template>
	<qw-input
		v-model="valueData"
		v-bind="$attrs"
		class="d-inline-block"
		:inputDebounceDelay="inputDebounceDelay"
		@change="onDataChanged"
		>
	</qw-input>
</template>

<script>

	import FormattedInput from "@/core/components/FormattedInput/FormattedInput.vue"
	import QwInput from "@/core/components/Controls/QwInput.vue";

    export default {
        name: "TimeEntryInput",
		components: {QwInput},
		extends: FormattedInput,
		props:{
			inputDebounceDelay: {Number, default: 200}
		},
		methods: {
			modelToValueMethod(model){
				let hours = Math.floor(model / (60 * 60 * 1000))
				let minutes = Math.floor(model / (60 * 1000) % 60)
				minutes = minutes < 10 ? "0" + minutes : minutes
				let res = hours + ":" + minutes
				return res
			},
			valueToModelMethod(value){
				let durationStr = Number(value.replace(/[^0-9]/g, '')).toString();//conversion to remove leading zeroes
				let l = durationStr.length
				let hours = 0
				let minutes = 0
				if(durationStr.length > 2){
					hours = Math.min(99, Number(durationStr.slice(0, l - 2)))
					minutes = Number(durationStr.slice(l-2, l))
				} else {
					let duration = Number(durationStr);
					hours = Math.floor(duration / 60)
					minutes = duration % 60
				}
				let res = (hours * 60 + minutes) * 60 * 1000
				return res
			}
		},
    }
</script>

<style>

</style>
